/**
 * handleSafetyError.js
 *
 * Shared helper for generation pages to gracefully handle safety-related
 * API errors (SERVICE_TIMEOUT and ACCOUNT_SUSPENDED) returned as 503/403.
 *
 * Usage:
 *   import { handleSafetyError } from '../utils/handleSafetyError';
 *   ...
 *   } catch (e) {
 *     if (handleSafetyError(e)) return; // stop — SafetyBanner will show
 *     toast.error(e.message);
 *   }
 */

/**
 * Returns true if the error was a safety event (SERVICE_TIMEOUT or
 * ACCOUNT_SUSPENDED), meaning the caller should NOT show a generic error.
 * The SafetyBanner listens to safetyEvents and will refresh itself automatically
 * via the Axios interceptor in api.js — so no extra action is needed here.
 */
export function handleSafetyError(error) {
  const status  = error?.response?.status;
  const errCode = error?.response?.data?.error;

  if (status === 503 && errCode === 'SERVICE_TIMEOUT') {
    // SafetyBanner will show the 30-min timeout strip automatically.
    return true;
  }

  if (status === 403 && errCode === 'ACCOUNT_SUSPENDED') {
    // SafetyBanner will show the suspension overlay automatically.
    return true;
  }

  return false;
}
